import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ArpioSharedModule } from '../shared/arpio-shared.module'
import { AwsMarketplaceErrorComponent } from './components/aws-marketplace-error/aws-marketplace-error.component'
import { AwsMarketplaceComponent } from './components/aws-marketplace/aws-marketplace.component'
import { SelectLinkedAccountComponent } from './components/select-linked-account/select-linked-account.component'

@NgModule({
  declarations: [AwsMarketplaceComponent, SelectLinkedAccountComponent, AwsMarketplaceErrorComponent],
  imports: [CommonModule, ArpioSharedModule],
})
export class AwsMarketplaceModule {}
